import {MONTHS} from "../../../../constants/Months";
import {DataHealthComparisonQuery} from "../../../../__generated__/generated_types";

export type MonthSelection = {year: number; monthIndex: number};

export function formatMonthLabel(m: MonthSelection): string {
    return `${MONTHS[m.monthIndex]} ${m.year}`;
}

export type PropertyDataHealthRow = DataHealthComparisonQuery["dataHealthComparison"][number];
export type MetricComparison = PropertyDataHealthRow["occupancyPct"];

export const METRIC_KEYS = ["occupancyPct", "unitCount", "marketRent", "inPlaceRent"] as const;
export type MetricKey = typeof METRIC_KEYS[number];

export const METRIC_LABELS: Record<MetricKey, string> = {
    occupancyPct: "Occupancy %",
    unitCount: "Unit Count",
    marketRent: "Market Rent",
    inPlaceRent: "In Place Rent",
};

export function showsAbsoluteChange(metric: MetricKey): boolean {
    return metric !== "occupancyPct";
}

export type MetricThreshold = {
    increase: number | null;
    decrease: number | null;
};

export type Thresholds = Record<MetricKey, MetricThreshold>;

export function emptyThresholds(): Thresholds {
    const result = {} as Thresholds;
    for (const key of METRIC_KEYS) {
        result[key] = {increase: null, decrease: null};
    }
    return result;
}
